import TriggerType from './model.js'
import { deepGet, addToCollection } from '../shared/helper'

export default {
  namespaced: true,
  state: {
    triggerTypes: [],
    filteredCollection: [],
    customerCollection: [],
    accountCollection: [],
    currentTrigger: new TriggerType(),
    currentCustomer: null,
  },
  getters: {
    getTriggerCollection: state => state.triggerTypes,
    getFilteredCollection: state => state.filteredCollection,
    getById: state => (id) => state.triggerTypes.find(triggerType => triggerType.id === id),
    getCurrentTrigger: state => state.currentTrigger,
    getCustomerCollection: state => state.customerCollection,
    getAccountCollection: state => state.accountCollection,
    getCurrentCustomer: state => state.currentCustomer
  },
  actions: {
    getTriggerCollection({ commit, getters, state }, payload) {
      return this.dispatch('get', {
        path: 'v1/triggerTypes',
        ...payload
      }).then((res) => {

        const data = deepGet(res, 'body.data')
        if (data) {

          const models = data.map((triggerType) => {
            commit('addTriggerTypeToCollection', { triggerTypeData: triggerType })
            return getters.getById(triggerType.id)
          })

          commit('addTriggerTypeToFilteredCollection', models)

          return { data: models, meta: res.body.meta }
        }
        return res
      })
    },
    getCustomerCollection({ commit }, payload) {
      const id = payload.id
      delete payload.id
      return this.dispatch('get', {
        path: 'v1/triggerTypes/' + id + '/customers',
        ...payload
      }).then((res) => {
        commit('updateCustomerCollection', res && res.body)
        return res && res.body
      })
    },
    getAccountCollection({ state, commit }, payload) {
      if (!state.currentCustomer) {
        throw Error('missing current customer')
      }
      const id = payload.id
      delete payload.id
      return this.dispatch('get', {
        path: `v1/triggerTypes/${id}/customers/${state.currentCustomer.id}/accounts`,
        ...payload
      }).then((res) => {
        commit('updateAccountCollection', res && res.body)
        return res && res.body
      })
    },
    create({ commit, getters }, model) {
      return this.dispatch('post', {
        path: 'v1/triggerTypes',
        data: model.getJSON()
      }).then((res) => {

        commit('addTriggerTypeToCollection', { triggerTypeData: res.body && res.body.data })

        return getters.getById(res.body && res.body.data.id)
      })
    },
    updateTrigger({ commit, getters }, model) {
      return this.dispatch('put', {
        path: 'v1/triggerTypes/' + model.id,
        data: model.getJSON()
      }).then((res) => {

        commit('addTriggerTypeToCollection', { triggerTypeData: res.body && res.body.data })

        return getters.getById(res.body && res.body.data.id)
      })
    },
    updateCustomerAccount({ state }, payload) {
      if (!state.currentCustomer) {
        throw Error('missing current customer')
      }
      return this.dispatch('put', {
        path: `v1/triggerTypes/${payload.id}/customers/${state.currentCustomer.id}/accounts`,
        data: payload
      })
    },
    delete({ commit }, id) {
      return this.dispatch('del', {
        path: 'v1/triggerTypes/' + id
      }).then((res) => {

        commit('removeTriggerTypeFromCollection', id)

        return res
      })
    }
  },
  mutations: {
    addTriggerTypeToCollection(state, { triggerTypeData, opts }) {
      addToCollection(this, state.triggerTypes, triggerTypeData, TriggerType, opts)
    },
    addTriggerTypeToFilteredCollection(state, data) {
      state.filteredCollection = state.filteredCollection.concat(data)
    },
    removeTriggerTypeFromCollection(state, triggerTypeId) {
      const index = state.triggerTypes.findIndex(el => el.id === triggerTypeId)

      if (index === -1) {
        console.warn(`Could not find/delete triggerType ${triggerTypeId}`)
        return
      }

      state.triggerTypes.splice(index, 1)
    },
    clearCollection(state) {
      state.triggerTypes = []
    },
    clearFilteredCollection(state) {
      state.filteredCollection = []
    },
    clearCustomerCollection(state) {
      state.customerCollection = []
    },
    clearAccountCollection(state) {
      state.accountCollection = []
    },
    updateAccountCollection (state, account) {
      state.accountCollection = state.accountCollection.concat(account.data)
    },
    updateCustomerCollection (state, customers) {
      state.customerCollection = state.customerCollection.concat(customers.data)
    },
    setCurrentTrigger (state, trigger) {
      state.currentTrigger = trigger
    },
    setCurrentCustomer (state, customer) {
      state.currentCustomer = customer
    },
    resetCurrentTrigger (state) {
      state.currentTrigger = new TriggerType()
    },
    resetCurrentCustomer (state) {
      state.currentCustomer = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/triggerType/store.js